/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { Link } from 'gatsby';
import logo from '../../../static/img/logo-icon.svg';
import './style.scss';
import '../../styles/emoji.css'; // For switcher lang icons
import '../../styles/font-awesome/css/all.css';

export default function Footer(props) {
  const [footer, setFooter] = useState(false);
  const [langSelected, setLangSelected] = useState(false);
  const [open, setOpen] = useState({});

  const openMenu = (i) => {
    setOpen({
      ...open,
      [i]: !open[i]
    });
  };

  if (typeof document !== 'undefined') {
    // Set all footer links as internals
    Array.from(document.querySelectorAll('footer a[target="_blank"]'))
      .forEach((link) => link.removeAttribute('target'));

    // Then, set all footer Strong links as externals, with target="_blank"
    Array.from(document.querySelectorAll('footer strong a'))
      .forEach((link) => link.setAttribute('target', '_blank'));
  }

  useEffect(() => {
    const { lang } = props;
    const footerObj = props.footer.edges
      .filter((item) => item.node.polylang_current_lang === lang && item.node.acf !== null && item.node.acf.footer_col_1)
      .map((item) => {
        return item.node.acf;
      });
    setFooter(footerObj[0]);
  }, [props, footer]);

  const handleChangeLang = (selectedLang) => {
    if (selectedLang.value !== props.lang) {
      setLangSelected(selectedLang);
      props.changeLang(selectedLang.value);
    }
  };

  const switcherLangs = [];

  props.langs.polylang_translations
    .map((item) => {
      const lg = item.polylang_current_lang;
      switcherLangs.push({
        value: lg,
        label: <div><i className={`em em-${lg}`} /><span style={{ color: '#031B4a' }}>{lg.toUpperCase()}</span></div>
      });
    });

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      paddingTop: '2px',
      paddingBottom: '2px',
      background: state.isSelected ? 'transparent' : 'white',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    }),
    control: (base) => ({
      ...base,
      outline: 0,
      userSelect: 'none',
      border: 0,
      boxShadow: 0,
      background: 'transparent',
      '&:hover, &:focus': {
        border: 0,
        boxShadow: 0,
        cursor: 'pointer'
      }
    }),
  };

  let companyLanding = false;
  let componentChunkName;
  if (typeof window !== 'undefined') {
    if (props.otherProps) {
      componentChunkName = props.otherProps.pageResources.page.componentChunkName;
      if (componentChunkName === 'component---src-pages-company-landing-company-js') {
        companyLanding = true;
      }
    }
  }

  return (
    <footer className={`footer ${companyLanding ? '' : 'dark-blue'}`}>
      <div className="container">
        <div className={`footer-grid ${footer.footer_col_3 === '' ? 'three-cols' : null }`}>
          <div className="grid-child logo">
            <Link to="/">
              <img
                src={logo}
                className="footer-logo"
                alt="iziwork"
                width="53"
                height="53"
              />
            </Link>
          </div>
          {footer.footer_col_1 &&
            <div className="grid-child">
              <div
                onClick={() => openMenu('menu1')}
                className={`list ${open.menu1 && 'open'}`}
                dangerouslySetInnerHTML={{
                  __html: footer.footer_col_1
                }}
              />
            </div>}
          {footer.footer_col_2 &&
            <div className="grid-child">
              <div
                onClick={() => openMenu('menu2')}
                className={`list ${open.menu2 && 'open'}`}
                dangerouslySetInnerHTML={{
                  __html: footer.footer_col_2
                }}
              />
            </div>}
          {footer.footer_col_3 &&
            <div className="grid-child">
              <div
                onClick={() => openMenu('menu3')}
                className={`list ${open.menu3 && 'open'}`}
                dangerouslySetInnerHTML={{
                  __html: footer.footer_col_3
                }}
              />
            </div>}
          {footer.footer_col_4 &&
            <div className="grid-child">
              <div
                onClick={() => openMenu('menu4')}
                className={`list ${open.menu4 && 'open'}`}
                dangerouslySetInnerHTML={{
                  __html: footer.footer_col_4
                }}
              />
            </div>}
        </div>
        <div className="footer-store-social">
          <div className="row">
            <div className="col-12 col-md-6">
              {footer.store_apple_image &&
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={footer.store_apple_url}
                  className="store"
                >
                  <img src={footer.store_apple_image.source_url} alt="" />
                </a>}
              {footer.store_google_image &&
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={footer.store_google_url}
                  className="store"
                >
                  <img src={footer.store_google_image.source_url} alt="" />
                </a>}
            </div>
            <div className="col-12 col-md-5 logo-container">
              <ul className="social-media">
                {footer.social_media_item_page && footer.social_media_item_page.map((item) => {
                  return (
                    <li key={item.image.source_url}>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={item.url}
                        className=""
                      >
                        <div className="overlay" />
                        <img
                          width="24"
                          height="24"
                          src={item.image.source_url} alt=""
                        />
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="col-12 col-md-1">
              <div className={`lang-switcher ${companyLanding ? 'light-footer' : null}`}>
                <Select
                  value={langSelected}
                  onChange={handleChangeLang}
                  options={switcherLangs}
                  styles={customStyles}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator: () => null,
                  }}
                  placeholder={<div><i className={`em em-${props.lang}`} /><span style={{ color: companyLanding ? '#031B4a' : 'white' }}>{props.lang.toUpperCase()}</span></div>}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="line" />
        <div className="row mt-3">
          <div
            className="link-text"
            dangerouslySetInnerHTML={{
              __html: footer.footer_horizontal_menu
            }}
          />
        </div>
        <div className="row">
          <div className="copyright">Copyright © {new Date().getFullYear()} iziwork</div>
        </div>
        <div className="row d-flex d-md-none justify-content-center mb-3">
          <img
            src={logo}
            className="footer-logo mobile-logo"
            alt="iziwork"
            width="53"
            height="53"
          />
        </div>
      </div>
    </footer>
  );
}
